import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { EnvironmentsSection } from './components/EnvironmentsSection';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FooterSection } from './components/FooterSection';
import { PurchasePopup } from './components/PurchasePopup';
import { StickyButton } from './components/StickyButton';
export function App() {
  useEffect(() => {
    // Meta Pixel
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '937331855399019');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=937331855399019&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
    return () => {
      document.head.removeChild(script);
      document.body.removeChild(noscript);
    };
  }, []);
  return <div className="min-h-screen bg-navy flex flex-col font-sans" data-id="element-0">
      <main className="flex-grow" data-id="element-1">
        <HeroSection data-id="element-2" />
        <StatsBar data-id="element-3" />
        <EnvironmentsSection data-id="element-4" />
        <TomosSection data-id="element-5" />
        <BonusSection data-id="element-6" />
        <TestimonialsSection data-id="element-7" />
        <PricingSection data-id="element-8" />
      </main>
      <FooterSection data-id="element-9" />
      <PurchasePopup data-id="element-10" />
      <StickyButton data-id="element-11" />
    </div>;
}